import { useEffect, useReducer, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import { Box, Card, CardHeader } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { apicall } from "../../../Integration/apicall";
import {
  FilterSlowMovingProducts,
  getallslowmovingproducts,
} from "./api/query";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import PageLoading from "../../../components/Loading/PageLoading";
import AddIcon from "@mui/icons-material/Add";
import RoleAccess from "../../function/RoleAccess";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  initialslowmovingproducts,
  slowmovingproductsreducer,
} from "./initialstate_and_reducer";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import { downloadExcelFile } from "../../function/downloadExcel";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Autocomplete,
  Chip,
  IconButton,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";

import { useLoading } from "../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { deleteslowmovingproducts, excelexport } from "./api/mutation";
import Swal from "sweetalert2";
import {
  realtimeInventoryState,
  RealtimeInventoryStateMange,
} from "../report/ReportStateMange";
import FilterListIcon from "@mui/icons-material/FilterList";
import ReusableFilter from "../../components/ReusableFilter";
import {
  allUsers,
  ExportSlowMovingProductReport,
  SlowMovingProductReport,
} from "../report/ReportData";
import OptionConvert from "../../components/OptionConvert";

const SlowmovingproductList = () => {
  const recordsPerPage = 5;
  const [value, setValue] = useState(0);
  const [rowData, setrowData] = useState([]);
  const [dateerror, setdateerror] = useState(false);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const { setCirleLoading } = useLoading();

  const [agentOptions, setAgentOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [productCategoryOptions, setProductCategoryOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [productOptions, setProductOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [brandOptions, setBrandOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [ageofStockOptions, setAgeofStockOptions] = useState([
    { label: "All", value: "All" },
  ]);

  const [dialogOpen, setDialogOpen] = useState(false);

  const navigate = useNavigate();
  const [SlowMovingItemsData, dispatch] = useReducer(
    RealtimeInventoryStateMange,
    realtimeInventoryState,
  );

  useEffect(() => {
    if (location.state != null) {
      setValue(location.state == 2 ? 0 : location.state);
      submitFilterData(location.state == 2 ? 0 : location.state);
    } else {
      submitFilterData(value);
    }
  }, [location]);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.all([fetchAgentName(), fetchAgesOfStock()]);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchAllData();
  }, []);

  // Function to reset all filters
  const resetFilters = () => {
    dispatch({ name: "reset" });
    fetchProuctComplianceData();
    setdateerror(false);
    setError("");
    submitFilterData(value);
  };

  const handleTabChange = async (event, newValue) => {
    await setValue(newValue);
    await submitFilterData(newValue);
  };

  // Function to fetch inventory data (initial load or reset)
  // const fetchInventoryData = () => {
  //   setIsLoading(true);
  //   request(BASEURL, SlowMovingItemsData)
  //     .then((res) => {
  //       const newdata = res?.SlowMovingItemsData?.data;
  //       setData(newdata);
  //       resetPagination(); // Reset graph pagination when data changes
  //     })
  //     .catch((err) => {
  //       const message =
  //         err?.response?.errors?.[0]?.message ||
  //         err?.message ||
  //         "Failed to fetch today's products.";
  //       Swal.fire({
  //         position: "top",
  //         icon: "error",
  //         title: message,
  //         showConfirmButton: true,
  //       });
  //       setData([]); // Clear data on error
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };

  const submitFilterData = async (value) => {
    const payload = {
      startDate: SlowMovingItemsData.fromDate || null,
      endDate: SlowMovingItemsData.toDate || null,
      brand:
        SlowMovingItemsData?.brand[0]?.value !== "All"
          ? SlowMovingItemsData.brand[0]?.label
          : null,
      productCategory:
        SlowMovingItemsData?.productCategory[0]?.value !== "All"
          ? SlowMovingItemsData.productCategory[0]?.label
          : null,
      slowMovingFor: value === 0 ? "Customer" : "Self",
    };

    setIsLoading(true);

    try {
      const res = await request(BASEURL, FilterSlowMovingProducts, payload);
      const apiRes = res?.filterSlowMovingProducts;

      const rows = apiRes?.data?.map((row, index) => ({
        ...row,
        sno: index + 1,
        createdOn: row?.createdAt?.slice(0, 10),
        createdBy: row?.user?.employeeName,
        customerName: row?.customer || "",
        Action: (
          <div
            style={{ display: "flex", marginTop: "10px", alignItems: "center" }}
          >
            <RoleAccess
              modelName="Slow Moving Products Screen"
              component="ViewSlowMovingProduct"
            >
              <VisibilityIcon
                fontSize="small"
                className="actionIcon"
                onClick={() =>
                  navigate(`/slow-moving-products/form`, {
                    state: { type: "view", data: row },
                  })
                }
              />
            </RoleAccess>
            <RoleAccess
              modelName="Slow Moving Products Screen"
              component="UpdateSlowMovingProduct"
            >
              <EditIcon
                fontSize="small"
                className="actionIcon"
                onClick={() =>
                  navigate(`/slow-moving-products/form`, {
                    state: { type: "edit", data: row },
                  })
                }
              />
            </RoleAccess>
            <RoleAccess
              modelName="Slow Moving Products Screen"
              component="DeleteSlowMovingProduct"
            >
              <DeleteIcon
                fontSize="small"
                className="actionIcon"
                onClick={() => handleDelte(row?.id, value)}
              />
            </RoleAccess>
          </div>
        ),
      }));

      setrowData(rows);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchProuctComplianceData = async () => {
    const res = apicall(getallslowmovingproducts).then((res) => {
      if (res.success) {
        const success = res.data.data.allSlowMovingProducts.success;
        const message = res.data.data.allSlowMovingProducts.message;
        const rowData = res.data.data.allSlowMovingProducts.data;
        const brand = OptionConvert(rowData, "brand", "id");
        setBrandOptions((prevOptions) => [
          { label: "All", value: "All" },
          ...brand,
        ]);
        const Categories = OptionConvert(rowData, "productCategory", "id");
        setProductCategoryOptions((prevOptions) => [
          { label: "All", value: "All" },
          ...Categories,
        ]);
        if (success) {
          const finalrow = rowData.map((row, index) => ({
            ...row,
            sno: index + 1,
            Action: (
              <div
                style={{
                  display: "flex",
                  marginTop: "10px",
                  alignItems: "center",
                }}
              >
                <RoleAccess
                  modelName="Slow Moving Products Screen"
                  component="ViewSlowMovingProduct"
                >
                  <VisibilityIcon
                    fontSize="small"
                    className="actionIcon"
                    onClick={() =>
                      navigate(`/slow-moving-products/form`, {
                        state: { type: "view", data: row },
                      })
                    }
                  />
                </RoleAccess>
                {value == 0 && (
                  <RoleAccess
                    modelName="Slow Moving Products Screen"
                    component="UpdateSlowMovingProduct"
                  >
                    <EditIcon
                      fontSize="small"
                      className="actionIcon"
                      // onClick={() => handleEditClick(v)}
                      onClick={() =>
                        navigate(`/slow-moving-products/form`, {
                          state: { type: "edit", data: row },
                        })
                      }
                    />
                  </RoleAccess>
                )}
                <RoleAccess
                  modelName="Slow Moving Products Screen"
                  component="DeleteSlowMovingProduct"
                >
                  <DeleteIcon
                    fontSize="small"
                    className="actionIcon"
                    onClick={() => handleDelte(row?.id)}
                  />
                </RoleAccess>
              </div>
            ),
          }));
          setrowData(finalrow);
        } else {
          setrowData([]);
        }
      } else {
        console.error("DATA not FETCHED");
      }
    });
  };

  const handleDelte = (id, val) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (del) => {
      if (del?.isConfirmed) {
        setCirleLoading(true);
        try {
          const res = await request(BASEURL, deleteslowmovingproducts, {
            id: id,
          });

          const success = res?.deleteSlowMovingProduct?.success;
          const message = res?.deleteSlowMovingProduct?.message;
          if (success) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            }).then(() => {
              submitFilterData(val);
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
        } catch (err) {
          console.error(err);
          Swal.fire({
            position: "top",
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: true,
          });
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  const SlowmovingproductListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Product Code",
        field: "productCode",
        name: "productCode",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      ...(value === 0
        ? [
            {
              headerName: "Customer Name",
              field: "customerName",
              name: "customerName",
              flex: 1,
              disableColumnMenu: true,
              editable: false,
            },
          ]
        : []),
      {
        headerName: "Product Name",
        field: "productName",
        name: "productName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Product Category",
        field: "productCategory",
        name: "productCategory",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },

      {
        headerName: "Age Of Stock",
        field: "ageOfStock",
        name: "ageOfStock",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Created By",
        field: "createdBy",
        name: "createdBy",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Created On",
        field: "createdOn",
        name: "createdOn",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: rowData,
  };

  //get ages Of Stock option
  const fetchAgesOfStock = () => {
    setIsLoading(true);
    request(BASEURL, getallslowmovingproducts)
      .then((res) => {
        const Categories = OptionConvert(
          res?.allSlowMovingProducts?.data,
          "productCategory",
          "id",
        );
        setProductCategoryOptions((prevOptions) => [
          { label: "All", value: "All" },
          ...Categories,
        ]);
        const brand = OptionConvert(
          res?.allSlowMovingProducts?.data,
          "brand",
          "id",
        );
        setBrandOptions((prevOptions) => [
          { label: "All", value: "All" },
          ...brand,
        ]);
        const product = OptionConvert(
          res?.allSlowMovingProducts.data,
          "productName",
          "id",
        );
        setProductOptions((prevOptions) => [...prevOptions, ...product]);
        const stock = OptionConvert(
          res?.allSlowMovingProducts.data,
          "ageOfStock",
          "id",
        );
        setAgeofStockOptions((prevOptions) => [...prevOptions, ...stock]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //get agent name option
  const fetchAgentName = () => {
    setIsLoading(true);
    request(BASEURL, allUsers)
      .then((res) => {
        const productName = OptionConvert(
          res?.allUsers,
          "employeeName",
          "email",
        );
        setAgentOptions((prevOptions) => [...prevOptions, ...productName]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //filter submit
  const submitFilter = (data) => {
    const agentName =
      SlowMovingItemsData?.agentName?.length > 0 &&
      !SlowMovingItemsData.agentName.some((item) => item.value === "All")
        ? SlowMovingItemsData.agentName.map((item) => item.value)
        : [];

    const productCategories =
      SlowMovingItemsData?.productCategory?.length > 0 &&
      !SlowMovingItemsData.productCategory.some((item) => item.label === "All")
        ? SlowMovingItemsData.productCategory.map((item) => item.label)
        : [];

    const productName =
      SlowMovingItemsData?.productName?.length > 0 &&
      !SlowMovingItemsData.productName.some((item) => item.label === "All")
        ? SlowMovingItemsData.productName.map((item) => item.label)
        : [];

    const agesOfStock =
      SlowMovingItemsData?.ageofStock?.length > 0 &&
      !SlowMovingItemsData.ageofStock.some((item) => item.value === "All")
        ? SlowMovingItemsData.ageofStock.map((item) => item.value)
        : [];

    const brands =
      SlowMovingItemsData?.brand?.length > 0 &&
      !SlowMovingItemsData.brand.some((item) => item.label === "All")
        ? SlowMovingItemsData.brand.map((item) => item.label)
        : [];

    fetchFilteredStock(
      SlowMovingItemsData.fromDate,
      SlowMovingItemsData.toDate,
      agentName,
      productCategories,
      productName,
      agesOfStock,
      brands,
    );
  };

  const fetchFilteredStock = (
    startDate,
    endDate,
    agents,
    productCategories,
    productName,
    agesOfStock,
    brands,
  ) => {
    setIsLoading(true);

    const payload = {
      startDate: startDate,
      endDate: endDate,
      agentNames: agents,
      productCategories: productCategories,
      productNames: productName,
      agesOfStock: agesOfStock,
      brands: brands,
      userIds: [],
    };

    request(BASEURL, SlowMovingProductReport, payload)
      .then((res) => {
        const newdata = res?.slowMovingProductReport?.data;
        const finalrow = newdata.map((row, index) => ({
          ...row,
          sno: index + 1,
          createdOn: row?.createdAt?.slice(0, 10),
          createdBy: row?.user?.employeeName,
          customerName: row?.customer || "",
          Action: (
            <div
              style={{
                display: "flex",
                marginTop: "10px",
                alignItems: "center",
              }}
            >
              <RoleAccess
                modelName="Slow Moving Products Screen"
                component="ViewSlowMovingProduct"
              >
                <VisibilityIcon
                  fontSize="small"
                  className="actionIcon"
                  onClick={() =>
                    navigate(`/slow-moving-products/form`, {
                      state: { type: "view", data: row },
                    })
                  }
                />
              </RoleAccess>

              <RoleAccess
                modelName="Slow Moving Products Screen"
                component="UpdateSlowMovingProduct"
              >
                <EditIcon
                  fontSize="small"
                  className="actionIcon"
                  // onClick={() => handleEditClick(v)}
                  onClick={() =>
                    navigate(`/slow-moving-products/form`, {
                      state: { type: "edit", data: row },
                    })
                  }
                />
              </RoleAccess>

              <RoleAccess
                modelName="Slow Moving Products Screen"
                component="DeleteSlowMovingProduct"
              >
                <DeleteIcon
                  fontSize="small"
                  className="actionIcon"
                  onClick={() => handleDelte(row?.id)}
                />
              </RoleAccess>
            </div>
          ),
        }));
        setrowData(finalrow);
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //download file
  const handleDownload = (
    startDate,
    endDate,
    agentsName,
    productName,
    productCategories,
    agesOfStock,
    brands,
  ) => {
    const agentsData =
      agentsName?.length > 0 && !agentsName.some((item) => item.value === "All")
        ? agentsName.map((item) => item.value)
        : [];

    const productData =
      productName?.length > 0 &&
      !productName.some((item) => item.label === "All")
        ? productName.map((item) => item.label)
        : [];

    const productCategorieData =
      productCategories?.length > 0 &&
      !productCategories.some((item) => item.value === "All")
        ? productCategories.map((item) => item.value)
        : [];

    const agesOfStockData =
      agesOfStock?.length > 0 &&
      !agesOfStock.some((item) => item.value === "All")
        ? agesOfStock.map((item) => item.value)
        : [];

    const brandData =
      brands?.length > 0 && !brands.some((item) => item.value === "All")
        ? brands.map((item) => item.value)
        : [];

    setCirleLoading(true);
    request(BASEURL, ExportSlowMovingProductReport, {
      startDate: startDate,
      endDate: endDate,
      agentNames: agentsData,
      productCategories: productCategorieData,
      productNames: productData,
      agesOfStock: agesOfStockData,
      brands: brandData,
      userIds: [],
    })
      .then(async (res) => {
        const status = res?.exportSlowMovingProductReport?.success;

        const pdfurl = `${URL}${res?.exportSlowMovingProductReport?.fileUrl?.slice(
          1,
        )}`;

        if (status) {
          const status = await downloadExcelFile(
            pdfurl,
            "slow_moving_items.xlsx",
          );
          setCirleLoading(false);
        }
      })
      .finally(() => {
        setCirleLoading(false);
      });
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Slow Moving Products List
                </MaterialTypography>
              </Stack>
              <Box sx={{ width: "25%", bgcolor: "Background.paper" }}>
                <Tabs
                  value={value}
                  onChange={handleTabChange}
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: "#2a9941",
                      color: "white",
                    },
                  }}
                  centered
                >
                  <Tab label="Customer" />

                  <Tab label="Self" />
                </Tabs>
              </Box>

              {/* Export File button, visible only when dates are selected */}
              <RoleAccess
                modelName="Slow Moving Products Screen"
                component="ExportSlowMovingProduct"
              >
                {SlowMovingItemsData?.fromDate &&
                  SlowMovingItemsData?.toDate && (
                    <button
                      className="container-btn-file"
                      onClick={() => {
                        handleDownload(
                          SlowMovingItemsData?.fromDate,
                          SlowMovingItemsData?.toDate,
                          SlowMovingItemsData?.productCategory,
                          SlowMovingItemsData?.brand,
                          SlowMovingItemsData?.productName,
                        );
                      }}
                      style={{
                        height: "38px",
                        marginLeft: "0",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      <svg
                        fill="#fff"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 50 50"
                      >
                        <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                      </svg>
                      Export File
                    </button>
                  )}
              </RoleAccess>
              <RoleAccess
                modelName="Slow Moving Products Screen"
                component="CreateSlowMovingProduct"
              >
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/slow-moving-products/form", {
                      state: { type: "add" },
                    })
                  }
                >
                  Slow Moving Product
                </MaterialButton>
              </RoleAccess>
            </Stack>
          }
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            bgcolor: "background.paper",
          }}
        >
          <IconButton
            onClick={() => setDialogOpen(true)}
            aria-label="Filters"
            color="primary"
            sx={{ mt: 2 }}
          >
            <FilterListIcon fontSize="large" />
          </IconButton>
          <IconButton
            onClick={resetFilters}
            aria-label="Reset Filters"
            color="primary"
            sx={{ mt: 2 }}
          >
            <RefreshIcon fontSize="large" />
          </IconButton>
        </Box>

        {/* Filter fields */}
        <ReusableFilter
          data={SlowMovingItemsData}
          dispatch={dispatch}
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onSave={(data) =>
            submitFilter({
              ...data,
              SlowMovingItemsData,
            })
          }
          title="Slow Moving Items Filter"
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Agent Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={agentOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={SlowMovingItemsData?.agentName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "agentName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Category(s)" />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Brand Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="brand-name-autocomplete"
              options={brandOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={SlowMovingItemsData?.brand || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "brand" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Brand(s)" />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Product Category
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="product-category-autocomplete"
              options={productCategoryOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={SlowMovingItemsData?.productCategory || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "productCategory" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Category(s)" />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Product Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={productOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={SlowMovingItemsData?.productName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "productName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Product(s)" />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Age of Stock
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={ageofStockOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={SlowMovingItemsData?.ageofStock || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "ageofStock" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Age of Stock(s)" />
              )}
            />
          </Grid>
        </ReusableFilter>

        <Box>
          {!isLoading && (
            <MaterialDataGrid
              rows={SlowmovingproductListTable?.rows}
              columns={SlowmovingproductListTable?.columns}
              isSelectable={false}
              localeText={{
                noRowsLabel: (
                  <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                  >
                    <MaterialTypography
                      variant="body2"
                      fontWeight="medium"
                      color="text"
                    >
                      No Slow moving products found
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                      You have not yet add any Slow moving products details.
                      Click on the "Add Slow moving products" button to start
                      adding Slow moving products details.
                    </MaterialTypography>
                  </Stack>
                ),
              }}
            />
          )}
        </Box>

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};
export default SlowmovingproductList;
